const Storage = require('utils/storage');
const PersistenceConfig = require('utils/persistence-config');
const ErrorStateUtils = require('hooks/useFormPrimitives/error');
const InvalidSubmitFocusUtils = require('./invalidSubmitFocusUtils');

const internals = {};

internals.debugInvalidSubmit = ({
    fields,
    formMethods,
    invalidFields
}) => {

    // eslint-disable-next-line no-console
    console.groupCollapsed('[__USER_INPUTS_DEBUG__ invalid submit]');
    // eslint-disable-next-line no-console
    console.log('fields', fields);
    // eslint-disable-next-line no-console
    console.log('invalidFields', invalidFields);
    // eslint-disable-next-line no-console
    console.log('values', typeof formMethods?.getValues === 'function' ? formMethods.getValues() : undefined);
    // eslint-disable-next-line no-console
    console.log('errors before clear/setError', formMethods?.formState?.errors);
};

internals.captureInvalidSubmitDebug = ({
    fields,
    formMethods,
    hasErrors,
    invalidFields,
    userPreferencesHasErrors,
    validate
}) => {

    if (typeof window === 'undefined') {
        return;
    }

    const getFieldName = (field) => typeof field === 'string' ? field : field.name;

    const describedInvalidFields = invalidFields.map((field) => {
        const name = getFieldName(field);
        let value;
        let errorMessage;

        try {
            value = formMethods?.getValues?.(name);
        }
        catch (err) {
            value = undefined;
        }

        try {
            errorMessage = validate(field);
        }
        catch (err) {
            errorMessage = err?.message || String(err);
        }

        return {
            name,
            label: field.label,
            type: field.type,
            component: field.component,
            required: field.required,
            render: field.render,
            visibleWhen: field.visibleWhen,
            validateWith: field.validateWith,
            value,
            errorMessage
        };
    });

    window.__FORM_DEBUG_LAST_INVALID_SUBMIT__ = {
        at: new Date().toISOString(),
        hasErrors,
        userPreferencesHasErrors,
        invalidFields: describedInvalidFields,
        allFieldNames: fields.map(getFieldName),
        values: typeof formMethods?.getValues === 'function' ? formMethods.getValues() : undefined,
        formStateErrors: formMethods?.formState?.errors
    };

    if (
        Storage.getItem(PersistenceConfig.keys.debug.formEnabled) === '1'
        || new URLSearchParams(window.location.search).get('formDebug') === '1'
    ) {
        // eslint-disable-next-line no-console
        console.log('[FormDebug] invalid submit', window.__FORM_DEBUG_LAST_INVALID_SUBMIT__);
    }
};

internals.setManualErrors = ({
    formMethods,
    invalidFields,
    validate
}) => {
    const manualErrors = {};

    if (formMethods) {
        formMethods.__manualFieldErrors = {};
    }

    if (formMethods?.clearErrors) {
        formMethods.clearErrors();
    }

    invalidFields.forEach((fieldName) => {
        const errorMessage = validate(fieldName);

        if (!errorMessage) {
            return;
        }

        manualErrors[fieldName] = {
            type: 'manual',
            message: errorMessage
        };

        if (!formMethods?.setError) {
            return;
        }

        formMethods.setError(fieldName, manualErrors[fieldName]);

        // eslint-disable-next-line no-console
        console.log('setError', fieldName, manualErrors[fieldName], typeof formMethods.getFieldState === 'function'
            ? formMethods.getFieldState(fieldName, formMethods.formState)
            : undefined);
    });

    if (formMethods) {
        formMethods.__manualFieldErrors = manualErrors;
        formMethods.__manualFieldErrorsVersion = Date.now();
    }

    // eslint-disable-next-line no-console
    console.log('errors after setError', formMethods?.formState?.errors);
    // eslint-disable-next-line no-console
    console.groupEnd();

    return manualErrors;
};

exports.handleInvalidSubmitIfNeeded = ({
    hasErrors,
    userPreferencesHasErrors,
    fields = [],
    formMethods,
    validate,
    housing,
    refs = {},
    specifyGenderTextfield,
    setUiState,
    onInvalidSubmit
}) => {

    if (!hasErrors && !userPreferencesHasErrors) {
        if (formMethods?.clearErrors) {
            formMethods.clearErrors();
        }

        if (formMethods) {
            formMethods.__manualFieldErrors = {};
            formMethods.__manualFieldErrorsVersion = Date.now();
        }

        return false;
    }

    const invalidFields = fields.filter(validate);

    internals.debugInvalidSubmit({
        fields,
        formMethods,
        invalidFields
    });

    internals.captureInvalidSubmitDebug({
        fields,
        formMethods,
        hasErrors,
        invalidFields,
        userPreferencesHasErrors,
        validate
    });

    internals.setManualErrors({
        formMethods,
        invalidFields,
        validate
    });

    setUiState({
        pageHasErrors: true,
        submitting: false
    });

    if (hasErrors) {
        housing?.current?.validateAndMaybeShowErr();

        setUiState(ErrorStateUtils.buildErrorVisibilityState({
            fields,
            validate
        }));
    }

    InvalidSubmitFocusUtils.scheduleFocusFirstInvalidField({
        fields,
        validate,
        refs,
        specifyGenderTextfield
    });

    if (typeof onInvalidSubmit === 'function') {
        onInvalidSubmit();
    }

    return true;
};

exports.internals = internals;
